import { ErrorObject, ValidateFunction } from 'ajv';
import addFormats from 'ajv-formats';
import { FormikErrors } from 'formik';
import Ajv2019 from 'ajv/dist/2019';
import { Address, PhoneNumber } from '../models/ProfileModel';

const ajv = new Ajv2019({ allErrors: true });
addFormats(ajv);

// todo define phone format appropriately
ajv.addFormat('phone', {
  type: 'number',
  validate: (x: any) => !!x,
});

let addressValidator: ValidateFunction<any>;
let phoneNumberValidator: ValidateFunction<any>;
const errorMessages = {
  type: 'Value is Required',
  required: 'Value is Required',
  maxLength: 'Invalid Value',
  pattern: 'Invalid Value',
  minLength: 'Value is Required',
};

function getFormikErrors(errors: ErrorObject[]) {
  const formattedErrors = {};
  errors.forEach((err) => {
    if (err.instancePath) {
      formattedErrors[err.instancePath.substring(1)] =
        errorMessages[err.keyword];
    } else if (err.params.missingProperty) {
      formattedErrors[err.params.missingProperty] = errorMessages[err.keyword];
    }
  });
  return formattedErrors;
}

function validateAddress(address: any, schema: any) {
  if (!addressValidator) addressValidator = ajv.compile(schema);
  const valid = addressValidator(address);
  let errors: FormikErrors<Address> = {};
  if (!valid) {
    errors = getFormikErrors(addressValidator.errors);
  }
  return { valid, errors };
}

function validatePhoneNumber(phoneNumber: any, schema: any) {
  if (!phoneNumberValidator) phoneNumberValidator = ajv.compile(schema);
  const valid = phoneNumberValidator(phoneNumber);
  let errors: FormikErrors<PhoneNumber> = {};
  if (!valid) {
    errors = getFormikErrors(phoneNumberValidator.errors);
  }
  return { valid, errors };
}

export default function useSchemaValidator() {
  return { validateAddress, validatePhoneNumber };
}
